import { Alert, Box, List, Text } from "@mantine/core";
import { IconAlertCircle, IconAlertTriangle } from "@tabler/icons";
import { useSession } from "next-auth/react";

const ContactInfo = () => {
    const { data: session, status } = useSession();

    return (
        <Box>
            <Text component="p" m={0}>
                If you have any questions or issues related, please contact our
                customer support team at :
            </Text>
            {!!session && (
                <List>
                    <List.Item>By Email : support@miningtest.tech</List.Item>
                    <List.Item>By Mobile : (+91) 9523629331</List.Item>
                </List>
            )}
            {!!!session && (
                <Alert
                    mt={10}
                    icon={<IconAlertTriangle size={26} />}
                    title="You are not logged in!"
                    color="red"
                    variant="outline"
                    mb={10}
                >
                    You need to be logged in to view the contact details.
                </Alert>
            )}
        </Box>
    );
};

export default ContactInfo;
